export const EBooleanStatuses = {
    True: true,
    False: false
}

export const EBooleanStatusesNumber = {
    True: 1,
    False: 0
}

export const Subscriptions = [
    {id: 'all', name: 'Multilanguage'},
]

export const AdvancedSubscriptions = [
    {id: 'ds_M1030DAYS_ADV', name: 'Advanced Monthly'},
    {id: 'ds_Q0090DAYS_ADV', name: 'Advanced Quarterly'},
]

export const SubscriptionSources = [
    {id: 1, name: 'Other'},
    {id: 2, name: 'DARE Academy'},
    {id: 3, name: 'Influencer'},
    {id: 4, name: 'Lifetime'},
    {id: 5, name: 'Sponsorship'},
    {id: 6, name: 'Landing'},
    {id: 7, name: 'app_resubscribe'},
]
export const SubscriptionList = [
    {id: 'en_multi_monthly', name: 'EN Multi Monthly'},
    {id: 'multilanguage', name: 'Multilanguage'},
    {id: 'en_multi_annual', name: 'EN Multi Annual'},
    {id: 'de_single_monthly', name: 'DE Single Monthly'},
    {id: 'de_single_annual', name: 'DE Single Annual'},
    {id: 'de_multi_monthly', name: 'DE Multi Monthly'},
    {id: 'de_multi_annual', name: 'DE Multi Annual'},
    {id: 'pt_single_monthly', name: 'PT Single Monthly'},
    {id: 'pt_single_annual', name: 'PT Single Annual'},
    {id: 'pt_multi_monthly', name: 'PT Multi Monthly'},
    {id: 'pt_multi_annual', name: 'PT Multi Annual'},
    {id: 'advanced_monthly', name: 'Advanced Monthly'},
    {id: 'advanced_quarterly', name: 'Advanced Quarterly'},
]
export const RatingSources = [
    {id: 0, name: 'Negative'},
    {id: 1, name: 'Positive'}
]